import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Zap, Shield, Heart } from 'lucide-react';
import LegalPageLayout from './LegalPageLayout';

// NOTE: Draft. Update copy with your final about-page voice when ready.

export default function AboutPage() {
  const values = [
    { icon: Zap,      title: 'Fast & frictionless',  body: 'Guests should be able to tip in under ten seconds. That principle drives every UI decision we make.' },
    { icon: Shield,   title: 'Fair by default',      body: 'A transparent 3% platform fee. No hidden charges. No pressure to upsell your guests. Ever.' },
    { icon: Heart,    title: 'Made for service pros',body: 'Bartenders, stylists, valets, drivers, food trucks — this app is built with the people who use it, not for them.' },
    { icon: Sparkles, title: 'A little competitive', body: 'The Top Earner Challenge lets pros share in a monthly pool. Because getting rewarded for great service should feel like a game, not a grind.' },
  ];
  return (
    <LegalPageLayout
      title="About Golden Tips"
      subtitle="A modern, dignified way for service pros to receive gratuities."
    >
      <section>
        <p className="text-lg text-[#D4D4D8]">
          Golden Tips started with a simple observation: the people who show up
          for us every day — the bartender who remembers your order, the
          stylist who saves your holiday party, the valet running in the
          rain — deserve a tip experience as good as the one they give.
        </p>
        <p>
          We built Golden Tips to make sending a tip as fast as tapping to
          pay for coffee — no app, no signup, no small talk about splitting
          change. And on the receiving side, we made it dignified: a clean
          personal page, a link and QR code that&apos;s yours, and payouts
          that land in your real bank account through Stripe.
        </p>
      </section>

      <section className="grid md:grid-cols-2 gap-4 not-prose mt-8">
        {values.map(({ icon: Icon, title, body }) => (
          <div key={title} className="stat-card" data-testid={`about-value-${title.split(' ')[0].toLowerCase()}`}>
            <Icon size={20} className="text-[#F5C542] mb-2" />
            <h3 className="font-heading font-semibold mb-1">{title}</h3>
            <p className="text-sm text-[#A1A1AA]">{body}</p>
          </div>
        ))}
      </section>

      <section className="mt-8">
        <h2 className="text-xl font-heading font-semibold text-white mt-2 mb-2">
          What we&apos;re not
        </h2>
        <p>
          We&apos;re not a payroll tool. We&apos;re not a POS. We&apos;re not
          trying to become your bank. Golden Tips does one thing well:
          getting the tips your work has already earned into your account
          quickly, transparently, and without a scene.
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-xl font-heading font-semibold text-white mt-2 mb-2">
          Ready to try it?
        </h2>
        <p>
          <Link to="/signup" className="text-[#F5C542] hover:underline">Create your Golden Tips link</Link>
          {' '}— free to set up, 3% platform fee, ready in under two minutes.
        </p>
      </section>
    </LegalPageLayout>
  );
}
